import { render, staticRenderFns } from "./interActionBtn.vue?vue&type=template&id=1bdcf0ea"
import script from "./interActionBtn.vue?vue&type=script&lang=js"
export * from "./interActionBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports